<template>
  <div class="ds-control ds-subtable ds-verticalsubtable" :class="[...getCss, { 'show-empty-text': showEmptyText }]">
    <div v-if="showLabel || buttonBars.length" class="ds-subtable-tools">
      <dsf-title v-if="showLabel" :value="label" class="ds-no-padding" style="float: left; margin-top: 5px" :font-type="3" :show-weight="true" :show-underline="showLabel && label ? labelShowUnderline : false" :show-color-lump="showLabel && label ? labelShowColorLump : false">
        <slot name="head-left"></slot>
      </dsf-title>
      <div class="head-right-item" style="float: right">
        <div v-if="showSearch" class="head-right-item-search" style="margin-left: 10px">
          <el-input v-model="searchStr" :placeholder="searchPlaceholder" class="search-input"></el-input>
          <button class="search-button">
            <i class="iconfont icon-fangdajing"></i>
          </button>
        </div>
        <slot name="head-right"></slot>
        <DsfButtonBar v-if="buttonBars.length" class="ds-no-padding" :owner="_self" :local="local" :buttons="buttonBars" :render-button="renderButton" :max-number="buttonsMaxNumber" :more-button-text="buttonsMoreButonText" :more-button-style="buttonsMoreButtonStyle" size="small" />
      </div>
    </div>
    <div class="ds-subtable-box">
      <!--设计时子表-->
      <el-table ref="table" :data="verticalTableValue" :class="{ disabledCheckHead: isSingleChecked }" :row-key="setRowKey" :height="tableHeight" :max-height="tableMaxHeight" :border="tableBorder" :span-method="spanMethod">
        <!-- 头部列 -->
        <DsfVerticalSubTableColumn v-for="column in headColumns" :key="column.columnId" :column="column" :isHeadCol="true">
        </DsfVerticalSubTableColumn>
        <!-- 主体数据列 -->
        <template v-if="!isReDrawHander">
          <DsfVerticalSubTableColumn v-for="column in bodyHeadCol" :key="column.$hash" :column="column">
            <template v-for="ite in verticalTableValue" v-slot:[ite._rowId]="scope">
              <template v-if="!isDesign">
                <el-popover :key="ite._rowId" placement="top" width="auto" popper-class="ds-vertical-sub-table-popover" trigger="hover">
                  <template>
                    <DsfButton v-if="
                                 scope._self.allowEdit &&
                                   !scope._self.foreverEditor &&
                                   renderRowButton('edit', scope.row) !== false
                               "
                               class="ds-subtable-button edit-button"
                               :class="['edit-button-' + scope.row.$hash]"
                               btn-style="icon-text"
                               size="small"
                               icon="tianxie"
                               title="修改"
                               style="min-width: auto"
                               @click="rowEditHandler(scope)"></DsfButton>
                    <DsfButton v-if="renderRowButton('delete', scope.row) !== false"
                               btn-style="icon-text"
                               size="small"
                               class="ds-subtable-button"
                               icon="shanchu"
                               :class="['delete-button-' + scope.row.$hash]"
                               title="删除"
                               style="min-width: auto"
                               v-show="
                                 !(
                                   isLeastOne &&
                                   scope.row.$index == 0 &&
                                   value.length == 1
                                 )
                               "
                               @click="rowDeleteHandler(scope)"></DsfButton>
                    <DsfButton v-if="renderRowButton('up', scope.row) !== false" btn-style="icon-text" size="small" class="ds-subtable-button ds-subtable-button-up" icon="shang" title="上移" :class="['up-button-' + scope.row.$hash]" style="min-width: auto" @click="rowUpHandler(scope)"></DsfButton>
                    <DsfButton v-if="renderRowButton('down', scope.row) !== false" btn-style="icon-text" size="small" class="ds-subtable-button ds-subtable-button-down" icon="xia" title="下移" :class="['down-button-' + scope.row.$hash]" style="min-width: auto" @click="rowDownHandler(scope)"></DsfButton>
                  </template>
                  <span slot="reference">
                    <div class="dsf-vertical-sub-table-col-cell">
                      <slot :name="ite._rowId" v-bind="scope"></slot>
                    </div>
                  </span>
                </el-popover>
              </template>
              <template v-else>
                <slot :name="ite._rowId" v-bind="scope"></slot>
              </template>
            </template>
          </DsfVerticalSubTableColumn>
        </template>
      </el-table>
    </div>
    <!--运行状态下分页-->
    <div v-if="showPagination && !isDesign" class="ds-subtable-footer">
      <el-pagination ref="pagination" :hide-on-single-page="true" :current-page="currentPage" :page-count="pageCount" :page-size="pageSize" :total="allList.length" :pager-count="pagerCount" background :layout="'total,prev,pager,next,jumper'" @current-change="currentChange"></el-pagination>
    </div>
  </div>
</template>

<script>
import DsfVerticalSubTableCellContent from "./verticalSubTableCellContent.vue";

let indexW = 60;
let selectionW = 60;
let operateW = 130;
let rowIndex = 0;

export default dsf.component({
  name: "DsfVerticalSubTable",
  ctrlCaption: "纵向子表",
  mixins: [$mixins.list, $mixins.oneToMany],
  provide() {
    return {
      $verticalSubTable: this
    };
  },
  props: {
    tableBorder: {
      type: Boolean,
      default: true
    },
    showLabel: {
      type: Boolean,
      default: false
    },
    labelShowUnderline: {
      type: Boolean,
      default: true
    },
    labelShowColorLump: {
      type: Boolean,
      default: true
    },
    value: {
      type: Array,
      default() {
        return [{}];
      }
    },
    isEditabled: {
      type: Boolean,
      default() {
        return true;
      }
    },
    columns: {
      type: Array,
      default() {
        return [];
      }
    },
    headColumns: {
      type: Array,
      default() {
        return [];
      }
    },
    //是否显示操作列
    isShowOperateColumn: {
      type: Boolean,
      default: true
    },
    //是否固定操作列
    isFixedOperateColumn: {
      type: Boolean,
      default: false
    },
    //是否显示索引列
    isShowIndexColumn: {
      type: Boolean,
      default: true
    },
    //是否固定索引列
    isFixedIndexColumn: {
      type: Boolean,
      default: false
    },
    indexColumnWidth: {
      type: Number,
      default: indexW
    },
    operateColumnWidth: {
      type: Number,
      default: operateW
    },
    // 是否强制全表可编辑
    foreverEditor: {
      type: Boolean,
      default: false
    },
    slots: {
      type: Array,
      default() {
        return [
          {
            name: "default",
            scope: "scope",
            controls: []
          }
        ];
      }
    },
    //是否允许分页
    showPagination: {
      type: Boolean,
      default: false
    },
    //分页页码按钮最多显示个数
    pagerCount: {
      type: Number,
      default: 5
    },
    //一页显示多少条记录
    pageSize: {
      type: Number,
      default: 15
    },
    buttonBars: {
      type: Array,
      default() {
        return [];
      }
    },
    renderButton: {
      type: Function,
      default: null
    },
    buttonsMoreButonText: {
      type: String,
      default: "更多"
    },
    buttonsMoreButtonStyle: {
      type: String,
      default: ""
    },
    buttonsMaxNumber: {
      type: Number,
      default: 4
    },
    removeRowBefore: {
      type: Function,
      default: function (next) {
        next();
      }
    },
    renderRowButton: {
      type: Function,
      default: dsf.noop
    },
    // 需要隐藏的列
    renderHeader: {
      type: Function,
      default: dsf.noop
    },
    //数据过滤
    filterData: {
      type: Function,
      default: null
    },
    //导出配置
    exportOptions: {
      type: [Object, Array],
      default() {
        return {
          "rule-1": []
        };
      }
    },
    isLeastOne: {
      type: Boolean,
      default: false
    },
    tableHeight: {
      type: [String, Number],
      required: false
    },
    tableMaxHeight: {
      type: [String, Number],
      required: false
    },
    //是否开启弹框新增
    isUseDialogEdit: {
      type: Boolean,
      default: false
    },
    //弹框地址
    editDialogUrl: {
      type: String,
      default: ""
    },
    //弹框标题
    editDialogTitle: {
      type: String,
      default: ""
    },
    //弹框宽度
    editDialogWidth: {
      type: String,
      default: ""
    },
    //弹框高度
    editDialogHeight: {
      type: String,
      default: ""
    },
    editDialogButtons: {
      type: Array,
      default() {
        return [
          { text: "确定", handler: "editDialogYes", isUser: false },
          { text: "下一条", handler: "editDialogNext", isUser: false },
          { text: "关闭", handler: "", isUser: false }
        ];
      }
    },
    getRowIndex: {
      type: Function,
      default: null
    },
    treeProps: {
      type: Object,
      default() {
        return { children: null, hasChildren: null };
      }
    },
    // 是否显示检索框
    showSearch: {
      type: Boolean,
      default: false
    },
    // 检索框提示文字
    searchPlaceholder: {
      type: String,
      default: "请输入检索关键字"
    },
    // 搜索字段
    searchFields: {
      type: String,
      default: ""
    },
    showEmptyText: {
      type: Boolean,
      default: false
    },
    renderCellClassName: {
      type: Function,
      default: null
    },
    renderCellStyle: {
      type: Function,
      default: null
    },
    renderRowSubControl: {
      type: Function,
      default: null
    },
    isExpandView: {
      type: Boolean,
      default: false
    },
    // 是否显示checkbox列
    isShowCheckboxColumn: {
      type: Boolean,
      default: false
    },
    // 是否仅单选
    isSingleChecked: {
      type: Boolean,
      default: false
    },
    //是否固定checkbox列
    isFixedCheckboxColumn: {
      type: Boolean,
      default: false
    },
    //选择列的宽度
    selectionColumnWidth: {
      type: Number,
      default: selectionW
    }
  },
  data() {
    return {
      isReDrawHander: true,
      deleted: [],
      currentPage: 1
    };
  },
  computed: {
    pageCount() {
      return Math.ceil(this.allList.length / this.pageSize);
    },
    headColsArray() {
      let headColumns = this.headColumns;
      rowIndex = 0;
      return headColsToArray(headColumns) || [];
    },
    headCols() {
      return this.headColsArray;
    },
    bodyHeadCol() {
      let value = this.list || [];
      let cols = value.map((v, i) => {
        return {
          $order: v.$order,
          $index: i,
          $hash: v.$hash,
          rowValue: v,
          label: "",
          columnId: "",
          level: 0,
          isLast: false,
          hide: false,
          headerAlign: "center",
          align: "center",
          resizable: false,
          width: "240",
          children: []
        };
      });
      return cols;
    },
    verticalTableValue() {
      let columns = this.columns;
      let colsArray = colsToArray.call(this, columns, this.headColsArray);
      return colsArray;
    },
    verticalTableRowColumnMerge() {
      let { columns, headColsArray } = this;
      let headColsDeepNum = headColsArray.length;
      let matrix = {};
      let rowIndex = 0;
      function deepForEach(columns, level = 0) {
        let num = 0;
        for (let i = 0; i < columns.length; i++) {
          const col = columns[i];
          let opt = {
            rowspan: 0,
            colspan: 1
          };
          matrix[`${rowIndex}-${level}`] = opt;
          if (col.children.length) {
            opt.rowspan += deepForEach(col.children, level + 1);
            num += opt.rowspan;
          } else {
            rowIndex++;
            num++;
            opt.rowspan = 1;
            opt.colspan = headColsDeepNum - level;
          }
        }
        return num;
      }
      deepForEach(columns);
      return matrix;
    },
    list() {
      let value = this.allList;
      let showPagination = this.showPagination;
      let pageSize = this.pageSize;
      let currentPage = this.currentPage;
      if (!this.isDesign) {
        // 搜索
        if (!this.filterData && this.showSearch && this.searchStr && this.searchFields) {
          var searchFields = this.searchFields.split(",");
          value = value.filter((item) => {
            let exit = false;
            searchFields.forEach((key) => {
              if (dsf.isObject(item[key])) {
                if (item[key]?.text?.indexOf(this.searchStr) > -1) {
                  exit = true;
                }
              } else if (dsf.isString(item[key]) && item[key]?.indexOf(this.searchStr) > -1) {
                exit = true;
              }
            });
            return exit;
          });
        }
        if (showPagination) {
          value = this.$getPageList(value, currentPage, pageSize);
        }
      }
      return value;
    },
    allList() {
      let value = this.value;
      if (this.filterData) {
        value = this.filterData(value);
        // 前端搜索
      }
      value.sort((a, b) => {
        return a.$order - b.$order;
      });
      return value;
    }
  },
  methods: {
    spanMethod(args) {
      const { verticalTableRowColumnMerge, headColsArray } = this;
      const key = `${args.rowIndex}-${args.columnIndex}`;
      let headColsDeepNum = headColsArray.length;
      if (args.columnIndex > headColsDeepNum - 1) {
        return {
          rowspan: 1,
          colspan: 1
        };
      }
      if (verticalTableRowColumnMerge[key]) {
        return verticalTableRowColumnMerge[key];
      }
      return {
        rowspan: 0,
        colspan: 0
      };
    },
    setRowKey(row) {
      return row.$hash;
    },
    buildSlots() {
      this.isReDrawHander = true;
      let useSlots = {};
      for (let i = 0; i < this.verticalTableValue.length; i++) {
        let slot = this.slots.find(({ name }) => {
          return name == this.verticalTableValue[i]._rowId;
        });
        if (!slot) {
          slot = {
            name: this.verticalTableValue[i]._rowId,
            scope: "scope",
            controls: [
              //此处默认追加一层组件,el-table貌似没有行数据加载过程中的控制事件，所以需要控制单元格中的子元素只能通过追加的一层组件完成
              dsf.designer.createComponent(DsfVerticalSubTableCellContent, {
                "slot-name": "default"
              })
            ]
          };
          slot.scope = "scope";
          slot.repeat = true;
          slot.textProxy = false;
          slot.dataKey = "row";
          this.slots.push(slot);
        }
        useSlots[slot.name] = 1; //push(slot.name);
      }
      let index = 0;
      while (index < this.slots.length) {
        const s = this.slots[index];
        if (s.name.indexOf("table-column-") == 0 || s.name.indexOf("column-") == 0) {
          if (!useSlots[s.name]) {
            this.slots.splice(index, 1);
            continue;
          }
        }
        index++;
      }
      this.$nextTick(() => {
        this.isReDrawHander = false;
      });
    },

    //分页组件页码变化
    async currentChange(evt) {
      this.currentPage = evt;
    },
    rowDeleteHandler(scope) {
      let fn = this.removeRowBefore;
      let result = dsf.toPromise(fn, scope.row);
      let deletedRow = () => {
        dsf.layer
          .confirm({
            message: "确认是否要删除？"
          })
          .then(() => {
            this.removeRow(scope.row, true);
            this.$dispatch("remove-row", scope.row);
          })
          .catch((err) => {
            console.error(err);
          });
      };
      result
        .then((res) => {
          if (res === true || dsf.isUnDef(res)) {
            deletedRow.call(this);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    rowEditHandler(scope) {
      if (!this.isUseDialogEdit) {
        this.editBegin(scope.row);
      } else {
        this.openDialogEdit({
          row: scope.row
        });
      }
    },
    rowUpHandler(scope) {
      this.isReDrawHander = true;
      let indexInCurrentPage = scope.$index;
      sort.call(this, scope, "up", () => {
        if (indexInCurrentPage == 0 && this.currentPage > 1) {
          this.currentPage--;
        }
      });
      this.$nextTick(() => {
        this.isReDrawHander = false;
      });
      this.$dispatch("order", this.value);
    },
    rowDownHandler(scope) {
      this.isReDrawHander = true;
      let indexInCurrentPage = scope.$index;
      sort.call(this, scope, "down", () => {
        if (indexInCurrentPage >= this.list.length - 1 && this.currentPage > 1) {
          this.currentPage++;
        }
      });
      this.$nextTick(() => {
        this.isReDrawHander = false;
      });
      this.$dispatch("order", this.value);
    },
    // 添加行
    pushRow(rows, isPageChange, isEdit = true) {
      let arr = [];
      if (dsf.type(rows) === "array") {
        arr = rows;
      } else if (dsf.type(rows) === "object") {
        arr = [rows];
      } else {
        dsf.layer.message("子表追加行数据格式错误！", false);
        dsf.error("子表追加行数据格式错误，必须为Object对象");
        return;
      }
      this.value.push(...arr);
      this.$nextTick(() => {
        if (isPageChange) {
          if (this.pageCount != this.currentPage) {
            this.currentPage = this.pageCount;
          }
        }
        setTimeout(() => {
          const tds = $(this.$el).find(".el-table__row").eq(0).find("td");
          tds.eq(tds.length - 1)[0].scrollIntoView();
        }, 250);
      });
    },
    // 插入行
    insertRow(row, index, isPageChange, isEdit = true) {
      this.value.splice(index, 0, row);
      this.$nextTick(() => {
        if (isPageChange) {
          //获取插入的新行在第几页
          let row = this.value[index];
          let rowIndex = _.findIndex(this.list, (it) => {
            return it == row;
          });
          let num = Math.floor(rowIndex / this.pageSize);
          if (num <= 0) {
            num = 1;
          }
          if (num != this.currentPage) {
            this.currentPage = num;
          }
        }
        // isEdit && this.editBegin(row);
      });
    },
    // 删除单行
    removeRow(data, isAppendToDeletedRows) {
      // this.editAllEnd();
      if (isAppendToDeletedRows) {
        dsf.array.remove(this.value, data);
        this.deleted.push(data);
      } else {
        dsf.array.remove(this.value, data);
      }
      if (!this.list.length && this.currentPage > 1) {
        this.currentPage--;
      }
    },
    // 删除多条数据
    removeRows(rows) {
      _.eachRight(rows, (row) => {
        row._id ? this.removeRow(row, true) : this.removeRow(row, false);
      });
    },
    //清空所有行
    clearRows() {
      _.eachRight(this.value, (row) => {
        row._id ? this.removeRow(row, true) : this.removeRow(row, false);
      });
    }
  },
  watch: {
    verticalTableValue: {
      immediate: true,
      handler(v) {
        this.buildSlots();
      }
    },
    value: {
      handler(v, o) {
        if (v) {
          if (this?.$vm?.$isReady && v.length <= 0) {
            this.createLeastOneRow();
            return;
          }
          for (let i = 0; i < v.length; i++) {
            let row = v[i];
            row.$index = i;
            this.attachMustFieldToData(row);
            this.setRowDefaultValue(row);
            this.updateIndexDataField(row, row.$index + 1);
          }
          if (this.$isLeastOne && dsf.isUnDef(v[0]._id)) {
            this.editBegin(v[0]);
          }
          if (o && v) {
            this.emitValueChange(v);
          }
        }
      },
      immediate: true
    }
  },
  created() {
    createDesignDefaultColumns.call(this);
    //兼容renderRowButton类型错误问题
    if (dsf.isDef(this.renderRowButton) && !dsf.isFunction(this.renderRowButton)) {
      this.$emit("update:renderRowButton", dsf.noop);
    }
  },
  mounted() {},
  design: {
    settingMenus: [
      ...($mixins.list.design.settingMenus || []),
      {
        text: "表头设置",
        command: "header-setting",
        handler: headerSetting
      }
    ]
  }
});
function headColsToArray(cols, colsArray = []) {
  for (let i = 0; i < cols.length; i++) {
    if (!cols[i].children || !cols[i].children.length) {
      colsArray.push(cols[i]);
      continue;
    } else {
      headColsToArray(cols[i].children || [], colsArray);
    }
  }
  return colsArray;
}
function colsToArray(headCols, headColsArray, level = 0) {
  let array = [];
  if (!headCols.length) {
    return {
      $index: rowIndex++,
      $hash: dsf.uuid(12)
    };
  }
  for (let i = 0; i < headCols.length; i++) {
    if (!this.isDesign && headCols[i].hide) {
      continue;
    }
    let result = colsToArray.call(this, headCols[i].children || [], headColsArray, level + 1);
    if (result.length == undefined) {
      result[`_${headColsArray[level].label}`] = headCols[i].label;
      result[`_rowId`] = headCols[i].columnId;
      array.push(result);
    } else {
      for (let j = 0; j < result.length; j++) {
        result[j][`_${headColsArray[level].label}`] = headCols[i].label;
      }
      array.push(...result);
    }
  }
  return array;
}

function createDesignDefaultColumns() {
  if (!this.isDesign) {
    return;
  }
  if (this.columns.length == 0) {
    let size = 4;
    for (let i = 0; i < size; i++) {
      addColumn.call(this, this.columns, {
        label: `表头${i}`,
        level: 0,
        width: 120,
        columnId: "table-column-" + dsf.math.numToEnglishLetter(i + 1)
      });
    }
  }
  if (this.headColumns.length == 0) {
    let size = 1;
    for (let i = 0; i < size; i++) {
      addColumn.call(this, this.headColumns, {
        label: `列头${i}`,
        level: 0,
        width: 120,
        columnId: "table-column-" + dsf.math.numToEnglishLetter(i + 1)
      });
    }
  }
}
//排序
function sort(scope, type, callback) {
  let row = this.list[scope.$index];
  let index = _.findIndex(this.value, (r) => r == row);
  let targetIndex = type == "up" ? index - 1 : index + 1;
  let targetRow = this.value[targetIndex];
  if (targetRow) {
    row.$order = targetIndex;
    targetRow.$order = index;
    this.$set(this.value, targetIndex, row);
    this.$set(this.value, index, targetRow);
    callback && callback(scope);
  }
}
function addColumn(columns, column, index, parentColumn) {
  let defaultColumn = {
    label: "",
    columnId: "",
    level: 0,
    isLast: false,
    hide: false,
    headerAlign: "center",
    align: "center",
    resizable: false,
    width: "auto",
    children: []
  };
  let col = dsf.mix({}, defaultColumn, column);
  if (parentColumn) {
    if (dsf.isUnDef(index)) {
      parentColumn.children.push(col);
      col.level = parentColumn.level + 1;
    } else {
      parentColumn.children.splice(index, 0, col);
    }
  } else {
    dsf.isUnDef(index) ? columns.push(col) : columns.splice(index, 0, col);
  }
  return col;
}
function headerSetting(item, proxy) {
  dsf.designer.triggerDialogPropty("columns");
}
</script>